<template functional>
    <img src="../maarima/images/maarima_icon.jpeg" />
    <!-- <svg class="compnow-logo" width="100%" height="100%" viewBox="0 0 900 900" :class="props.theme">
        <rect x="300" width="600" height="300" class="icon" />
        <rect x="300" y="600" width="600" height="300" class="icon" />
        <rect y="300" width="300" height="300" class="icon" />
    </svg> -->
</template>

<script>
export default {
    name: 'maarima-logo-icon',
    props: {
        theme: {
            type: String
        }
    }
}
</script>

<style scoped lang="scss">
@import 'logoColors.scss';
</style>
